import { render, staticRenderFns } from "./PropertyReservationSetup.vue?vue&type=template&id=2f6ef29c&scoped=true&"
import script from "./PropertyReservationSetup.vue?vue&type=script&lang=js&"
export * from "./PropertyReservationSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6ef29c",
  null
  
)

export default component.exports